/* KS cart drawer — compact foot helpers for third-party AIOD widgets.
 *
 * - Collapses the AIOD coupon input to a text toggle (mockup: 有折扣碼？點此輸入 ＋)
 * - Re-applies when AIOD reinjects widgets after cart refresh
 */
(function () {
  if (window.__ksCartDrawerCompact) return;
  window.__ksCartDrawerCompact = true;

  const ENHANCED_ATTR = 'data-ks-aiod-coupon-enhanced';
  const COLLAPSED_CLASS = 'ks-aiod-coupon-collapsed';
  const TOGGLE_LABEL = '有折扣碼？點此輸入 ＋';

  function getDrawerFoot() {
    return document.querySelector('.drawer--cart .drawer__foot');
  }

  function findCouponContainers(root) {
    if (!root) return [];

    const matches = Array.from(
      root.querySelectorAll('.aiod-widget-container-side-cart, .aiod-coupon-container')
    ).filter(function (node) {
      return node.querySelector('.aiod-coupon-input-group');
    });

    // AIOD nests .aiod-coupon-container inside .aiod-widget-container-side-cart.
    // Enhance the outer wrapper only so we don't render two toggles.
    return matches.filter(function (node) {
      return !matches.some(function (other) {
        return other !== node && other.contains(node);
      });
    });
  }

  function enhanceCoupon(container) {
    if (!container || container.hasAttribute(ENHANCED_ATTR)) return;

    container.querySelectorAll('.ks-aiod-coupon-toggle').forEach(function (node) {
      node.remove();
    });

    container.setAttribute(ENHANCED_ATTR, 'true');
    container.classList.add(COLLAPSED_CLASS);

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ks-aiod-coupon-toggle';
    toggle.textContent = TOGGLE_LABEL;

    toggle.addEventListener('click', function () {
      container.classList.remove(COLLAPSED_CLASS);
      toggle.remove();

      const input = container.querySelector('.aiod-coupon-input');
      if (input) {
        window.requestAnimationFrame(function () {
          input.focus();
        });
      }
    });

    container.insertBefore(toggle, container.firstChild);
  }

  function scan() {
    const foot = getDrawerFoot();
    if (!foot) return;

    findCouponContainers(foot).forEach(enhanceCoupon);
  }

  function scheduleScan() {
    window.clearTimeout(window.__ksCartDrawerCompactTimer);
    window.__ksCartDrawerCompactTimer = window.setTimeout(scan, 50);
  }

  function startObserver() {
    const foot = getDrawerFoot();
    if (!foot) return;

    const observer = new MutationObserver(scheduleScan);
    observer.observe(foot, { childList: true, subtree: true });
    scan();
  }

  function bindEvents() {
    [
      'theme:cart:change',
      'theme:cart-drawer:open',
      'cart:refresh',
      'AIOD_WIDGET_CONTAINERS_INITIALIZED',
    ].forEach(function (name) {
      document.addEventListener(name, scheduleScan);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      bindEvents();
    });
  } else {
    startObserver();
    bindEvents();
  }
})();
